import Swiper from "swiper/bundle";
import { Fancybox } from "@fancyapps/ui";
import ModuleShowcase from "../components/ModuleShowcase";

export default class EventDetailsPage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initSliders();
    this.initFancyBox();
    this.initShowcase();
  }

  initSliders() {
    const gallerySwiperDOM = this.dom.querySelector(".gallery-slider");
    if (gallerySwiperDOM != undefined) {
      let gallerySwiper = new Swiper(gallerySwiperDOM, {
        slidesPerView: "auto",
        spaceBetween: 30,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  }

  initFancyBox() {
    const gallerySwiperDOM = this.dom.querySelector(".gallery-slider");
    Fancybox.bind(gallerySwiperDOM, "[data-fancybox]", {
      wheel: "slide",
    });
  }

  initShowcase() {
    const showcaseDOMs = this.dom.querySelectorAll(".showcase-wrapper");
    if (showcaseDOMs.length > 0) {
      for (let showcaseDOM of showcaseDOMs) {
        this.showcase = new ModuleShowcase(showcaseDOM);
        this.showcase.init();
      }
    }
  }

  resize() {}
}
